"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es6.reflect.construct");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));

var _inherits2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js"));

var _getPrototypeOf2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js"));

var _tslib = require("tslib");

var _vuePropertyDecorator = require("vue-property-decorator");

var _helper = require("@/mixins/helper/helper");

var _theme = require("@/mixins/theme/theme");

var _variables = _interopRequireDefault(require("@/styles/mixins/_variables.scss"));

var _gaugeChart = require("./gauge-chart.constants");

var _echarts = _interopRequireDefault(require("echarts"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var GaugeChartComponent = /*#__PURE__*/function (_Mixins) {
  (0, _inherits2.default)(GaugeChartComponent, _Mixins);

  var _super = _createSuper(GaugeChartComponent);

  function GaugeChartComponent() {
    var _this;

    (0, _classCallCheck2.default)(this, GaugeChartComponent);
    _this = _super.apply(this, arguments);
    _this.chart = null;
    return _this;
  }

  (0, _createClass2.default)(GaugeChartComponent, [{
    key: "onCharDataChanges",
    value: function onCharDataChanges(newVal, oldVal) {
      this.setChartData();
      this.chart.resize();
    }
  }, {
    key: "onThemeChanges",
    value: function onThemeChanges() {
      this.resetCharts();
      this.initChart();
    }
  }, {
    key: "beforeDestroy",
    value: function beforeDestroy() {
      this.resetCharts();
      window.removeEventListener('resize', this.handleChartResize());
    }
  }, {
    key: "mounted",
    value: function mounted() {
      this.initChart();
      window.addEventListener('resize', this.handleChartResize());
    }
  }, {
    key: "resetCharts",
    value: function resetCharts() {
      if (!this.chart) {
        return;
      }

      this.chart.dispose();
      this.chart = null;
    }
  }, {
    key: "initChart",
    value: function initChart() {
      this.chart = _echarts.default.init(this.$el, this.getEchartTheme);
      this.setChartData();
    }
  }, {
    key: "setChartData",
    value: function setChartData() {
      switch (this.chartType) {
        case '':
          this.handleDefaultChart();
          break;

        default:
          this.handleDefaultChart();
      }
    }
  }, {
    key: "handleDefaultChart",
    value: function handleDefaultChart() {
      var chartOption = this.helper.cloneDeep(_gaugeChart.GAUGE_CHART_SETTINGS);
      chartOption['series'] = [{
        name: '%',
        type: 'gauge',
        detail: {
          formatter: '{value}%',
          offsetCenter: [0, '100%']
        },
        data: [{
          value: this.chartData[0]
        }],
        axisLabel: {
          show: false
        },
        axisLine: {
          lineStyle: {
            color: [[0.2, _variables.default['red']], [0.4, _variables.default['orange']], [0.6, _variables.default['yellow']], [0.8, _variables.default['green']], [1, _variables.default['bay-blue-dark']]],
            width: 3,
            shadowBlur: 10
          }
        }
      }];
      this.chart.setOption(chartOption);
    }
  }, {
    key: "handleChartResize",
    value: function handleChartResize() {
      var _this2 = this;

      return this.helper.debounce(function () {
        if (_this2.chart) {
          _this2.chart.resize();
        }
      }, 100);
    }
  }]);
  return GaugeChartComponent;
}((0, _vuePropertyDecorator.Mixins)(_helper.HelperMixin, _theme.ThemeMixin));

(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: String,
  default: '100%'
})], GaugeChartComponent.prototype, "width", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: String,
  default: '250px'
})], GaugeChartComponent.prototype, "height", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Array,
  default: []
})], GaugeChartComponent.prototype, "chartData", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: String,
  default: ''
})], GaugeChartComponent.prototype, "chartType", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('chartData')], GaugeChartComponent.prototype, "onCharDataChanges", null);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('$isDarkTheme')], GaugeChartComponent.prototype, "onThemeChanges", null);
GaugeChartComponent = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'GaugeChartComponent',
  components: {}
})], GaugeChartComponent);
var _default = GaugeChartComponent;
exports.default = _default;